import { ModelType } from 'components/filter/types-legacy';
import { FilterParams } from 'types/params';

export const segmentQueryKeys = {
    all: (accountId: number, type: ModelType) => ['segments', accountId, type],
    withFilters: (accountId: number, type: ModelType, filters: FilterParams = {}) => [
        ...segmentQueryKeys.all(accountId, type),
        filters,
    ],
};
